/* ============================================================================
   OMEN Quiz PDP — Section JavaScript
   - Profile detection from URL ?profile= (ALTO | MOD-ALTO | MOD)
   - Fear detection from URL ?fear= (1|2|3) — fills [data-fear-text] in Bad News
   - Hero variant + protocol justification + sticky label switching
   - Recommended tier badge + auto-select + dynamic CTA text per tier
   - FAQ accordion (aria-expanded)
   - Sticky CTA reveal after hero scroll
   - Tracking via image-pixel GET (Apps Script-safe, no CORS)
   ============================================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var sections = document.querySelectorAll('.shopify-section.section-omen-quiz-pdp');
    if (!sections.length) return;
    sections.forEach(initSection);
  });

  function initSection(sectionRoot) {
    var pdpRoot = sectionRoot.querySelector('.omen-pdp');
    if (!pdpRoot) return;
    var cfg = sectionRoot.querySelector('#omen-tracking-config');
    var defaultProfile = (cfg && cfg.dataset.defaultProfile) || 'MOD-ALTO';
    var webhook = (cfg && cfg.dataset.webhook) || '';
    var variant = (cfg && cfg.dataset.variant) || '';
    var startTime = Date.now();
    var sessionId = getSessionId();

    var profile = detectProfile(defaultProfile);
    applyProfile(pdpRoot, profile);
    track('profile_detected', { profile: profile });

    var fear = detectFear();
    applyFear(pdpRoot, fear);

    var recommendedTierMap = {
      'ALTO':     getDataAttr(pdpRoot, 'data-rec-alto')     || 'tier_6',
      'MOD-ALTO': getDataAttr(pdpRoot, 'data-rec-modalto')  || 'tier_3',
      'MOD':      getDataAttr(pdpRoot, 'data-rec-mod')      || 'tier_3'
    };
    var recTier = recommendedTierMap[profile] || 'tier_3';
    setupPricing(pdpRoot, recTier);
    setupFaq(pdpRoot);
    setupCarousels(pdpRoot);
    setupTikTokVideos(pdpRoot);
    setupSticky(pdpRoot);
    setupNativeATC(pdpRoot);
    setupSmoothScroll(pdpRoot);
    setupTracking(pdpRoot, sectionRoot);

    function detectProfile(fallback) {
      try {
        var qs = new URLSearchParams(window.location.search);
        var raw = (qs.get('profile') || qs.get('p') || '').trim().toUpperCase();
        if (raw === 'ALTO' || raw === 'HIGH' || raw === 'A') return 'ALTO';
        if (raw === 'MOD-ALTO' || raw === 'MODALTO' || raw === 'MOD_ALTO' || raw === 'MA') return 'MOD-ALTO';
        if (raw === 'MOD' || raw === 'MODERATE' || raw === 'MODERADO' || raw === 'M') return 'MOD';
      } catch (e) {}
      return (fallback || 'MOD-ALTO').toUpperCase();
    }

    function detectFear() {
      try {
        var qs = new URLSearchParams(window.location.search);
        var raw = (qs.get('fear') || '').trim();
        if (raw === '1' || raw === '2' || raw === '3') return raw;
      } catch (e) {}
      return null;
    }

    function applyFear(root, fearVal) {
      var els = root.querySelectorAll('[data-fear-text]');
      if (!els.length) return;
      var FEAR_TEXT = {
        '1': 'Marcaste que lo que más te preocupa es que esto siga empeorando con el tiempo.',
        '2': 'Marcaste que lo que más te preocupa es que la gente lo note antes que vos.',
        '3': 'Marcaste que lo que más te preocupa es tener que recurrir a tratamientos caros o invasivos.'
      };
      var text = fearVal && FEAR_TEXT[fearVal] ? FEAR_TEXT[fearVal] : '';
      for (var i = 0; i < els.length; i++) {
        els[i].textContent = text;
        els[i].style.display = text ? '' : 'none';
      }
    }

    function applyProfile(root, profileVal) {
      var nodes = root.querySelectorAll('[data-profile-variant]');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.getAttribute('data-profile-variant') === profileVal) n.classList.add('is-active');
        else n.classList.remove('is-active');
      }
      root.setAttribute('data-active-profile', profileVal);
    }

    function setupPricing(root, recommendedTier) {
      var offers = root.querySelectorAll('.omen-pdp__offer');
      for (var i = 0; i < offers.length; i++) applyRecommendedToOffer(offers[i], recommendedTier);
    }

    function applyRecommendedToOffer(offerEl, recommendedTier) {
      var tiers = offerEl.querySelectorAll('.omen-pdp__tier');
      for (var i = 0; i < tiers.length; i++) {
        var t = tiers[i];
        var tName = t.getAttribute('data-tier');
        var radio = t.querySelector('.omen-pdp__tier-radio');
        if (tName === recommendedTier) {
          t.classList.add('is-recommended');
          if (radio && !radio.checked) radio.checked = true;
        } else {
          t.classList.remove('is-recommended');
        }
      }
      updateAtcButtonText(offerEl);
      offerEl.addEventListener('change', function (e) {
        var radio = e.target.closest('.omen-pdp__tier-radio');
        if (!radio) return;
        track('tier_select', { position: offerEl.getAttribute('data-offer-position') || '', tier: radio.value, was_recommended: radio.value === recommendedTier });
        updateAtcButtonText(offerEl);
      });
    }

    function updateAtcButtonText(offerEl) {
      var checked = offerEl.querySelector('.omen-pdp__tier-radio:checked');
      if (!checked) return;
      var label = checked.closest('.omen-pdp__tier');
      if (!label) return;
      var ctaText = label.getAttribute('data-cta-text');
      if (!ctaText) return;
      var span = offerEl.querySelector('.omen-pdp__cta-text');
      if (span) span.textContent = ctaText;
    }

    function setupFaq(root) {
      var btns = root.querySelectorAll('.omen-pdp__faq-q');
      for (var i = 0; i < btns.length; i++) bindFaqButton(btns[i]);
    }

    function bindFaqButton(btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var ans = btn.nextElementSibling;
        if (ans) ans.hidden = expanded;
        if (!expanded) track('faq_open', { question: (btn.textContent || '').trim().substring(0, 80) });
      });
    }

    function setupCarousels(root) {
      var carousels = root.querySelectorAll('[data-carousel]');
      for (var i = 0; i < carousels.length; i++) bindCarousel(carousels[i]);
    }

    function bindCarousel(carousel) {
      var trackEl = carousel.querySelector('[data-carousel-track]');
      if (!trackEl) return;
      var slides = carousel.querySelectorAll('[data-carousel-slide]');
      var dots = carousel.querySelectorAll('[data-carousel-dot]');
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      if (!slides.length) return;
      var carouselName = carousel.getAttribute('data-carousel') || 'unknown';
      var scrollTimeout;
      trackEl.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var center = trackEl.scrollLeft + (trackEl.clientWidth / 2);
          var closestIdx = 0, closestDist = Infinity;
          for (var i = 0; i < slides.length; i++) {
            var sCenter = slides[i].offsetLeft + (slides[i].offsetWidth / 2);
            var dist = Math.abs(center - sCenter);
            if (dist < closestDist) { closestDist = dist; closestIdx = i; }
          }
          updateDots(closestIdx); updateArrows(closestIdx);
        }, 80);
      });
      function updateDots(activeIdx) {
        for (var i = 0; i < dots.length; i++) {
          if (i === activeIdx) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-selected', 'true'); }
          else { dots[i].classList.remove('is-active'); dots[i].setAttribute('aria-selected', 'false'); }
        }
      }
      function updateArrows(activeIdx) {
        if (prevBtn) prevBtn.disabled = activeIdx <= 0;
        if (nextBtn) nextBtn.disabled = activeIdx >= slides.length - 1;
      }
      function scrollToSlide(idx) {
        if (idx < 0) idx = 0; if (idx >= slides.length) idx = slides.length - 1;
        var slide = slides[idx]; if (!slide) return;
        trackEl.scrollTo({ left: slide.offsetLeft - trackEl.offsetLeft, behavior: 'smooth' });
        track('carousel_navigate', { carousel: carouselName, slide_index: idx });
      }
      for (var i = 0; i < dots.length; i++) { (function (idx) { dots[idx].addEventListener('click', function () { scrollToSlide(idx); }); })(i); }
      if (prevBtn) prevBtn.addEventListener('click', function () { scrollToSlide(getCurrentSlideIdx() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollToSlide(getCurrentSlideIdx() + 1); });
      function getCurrentSlideIdx() {
        var center = trackEl.scrollLeft + (trackEl.clientWidth / 2);
        for (var i = 0; i < slides.length; i++) { if (slides[i].offsetLeft + slides[i].offsetWidth >= center) return i; }
        return slides.length - 1;
      }
      updateDots(0); updateArrows(0);
    }

    function setupTikTokVideos(root) {
      var cards = root.querySelectorAll('.omen-pdp__tiktok-card');
      for (var i = 0; i < cards.length; i++) bindTikTokCard(cards[i]);
    }

    function bindTikTokCard(card) {
      var video = card.querySelector('[data-tiktok-video]');
      var playBtn = card.querySelector('[data-tiktok-play]');
      if (!video) { if (playBtn) playBtn.style.display = 'none'; return; }
      function play() {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
        card.classList.add('is-playing');
        track('tiktok_play', { video_src: (video.currentSrc || video.src || '').substring(0, 100) });
      }
      function pause() { video.pause(); card.classList.remove('is-playing'); }
      card.addEventListener('click', function (e) {
        if (e.target.closest('.omen-pdp__tiktok-caption')) return;
        if (video.paused) play(); else pause();
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (!entry.isIntersecting && !video.paused) pause(); });
        }, { threshold: 0.5 });
        io.observe(card);
      }
      video.addEventListener('ended', function () { card.classList.remove('is-playing'); try { video.currentTime = 0; } catch (e) {} });
    }

    function setupSticky(root) {
      var sticky = root.querySelector('.omen-pdp__sticky');
      if (!sticky) return;
      var hero = root.querySelector('.omen-pdp__hero');
      if (!hero) { sticky.classList.add('is-visible'); sticky.setAttribute('aria-hidden', 'false'); return; }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio < 0.2) { sticky.classList.add('is-visible'); sticky.setAttribute('aria-hidden', 'false'); }
            else { sticky.classList.remove('is-visible'); sticky.setAttribute('aria-hidden', 'true'); }
          });
        }, { threshold: [0, 0.2, 0.5] });
        io.observe(hero);
      } else {
        window.addEventListener('scroll', function () {
          if (window.scrollY > 400) { sticky.classList.add('is-visible'); sticky.setAttribute('aria-hidden', 'false'); }
          else { sticky.classList.remove('is-visible'); sticky.setAttribute('aria-hidden', 'true'); }
        }, { passive: true });
      }
    }

    function setupNativeATC(root) {
      var forms = root.querySelectorAll('.omen-pdp__offer');
      if (!forms.length) return;
      Array.prototype.forEach.call(forms, function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var slot = form.getAttribute('data-offer-position') || 'primary';
          var qtyInput = form.querySelector('input[name="quantity"]:checked');
          var qty = qtyInput ? qtyInput.value : '1';
          track('cta_click', { cta_id: 'native_atc', slot: slot, quantity: qty });

          var btn = form.querySelector('button[type="submit"]');
          if (btn) { btn.disabled = true; }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: form.querySelector('input[name="id"]').value, quantity: parseInt(qty, 10) || 1 }]
            })
          })
            .then(function (res) { return res.json(); })
            .then(function () {
              window.location.href = '/checkout';
            })
            .catch(function () {
              form.submit();
            });
        }, false);
      });
    }

    function setupSmoothScroll(root) {
      root.addEventListener('click', function (e) {
        var link = e.target.closest('a[href^="#"]');
        if (!link) return;
        var href = link.getAttribute('href');
        if (!href || href === '#' || href.length < 2) return;
        var target = root.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var ctaName = link.getAttribute('data-cta');
        if (ctaName) track('cta_click', { cta: ctaName, text: (link.textContent || '').trim().substring(0, 50), target: href });
      });
    }

    function setupTracking(root, sectionEl) {
      var qs = new URLSearchParams(window.location.search);
      track('page_view', {
        page_url: window.location.href, referrer: document.referrer || '',
        utm_source: qs.get('utm_source') || '', utm_medium: qs.get('utm_medium') || '',
        utm_campaign: qs.get('utm_campaign') || '', utm_content: qs.get('utm_content') || '',
        utm_term: qs.get('utm_term') || '', fear: qs.get('fear') || ''
      });
      root.addEventListener('click', function (e) {
        var link = e.target.closest('[data-cta]');
        if (!link) return;
        var href = link.getAttribute('href') || '';
        if (href.indexOf('#') === 0) return;
        track('cta_click', { cta: link.getAttribute('data-cta'), text: (link.textContent || '').trim().substring(0, 50), url: href });
      });
      var marks = [25, 50, 75, 100], fired = {};
      window.addEventListener('scroll', function () {
        var doc = document.documentElement;
        var h = (doc.scrollHeight || document.body.scrollHeight) - window.innerHeight;
        if (h <= 0) return;
        var pct = Math.round((window.scrollY / h) * 100);
        for (var i = 0; i < marks.length; i++) { var m = marks[i]; if (pct >= m && !fired[m]) { fired[m] = true; track('scroll_depth', { depth: m }); } }
      }, { passive: true });
      if ('IntersectionObserver' in window) {
        var sectionObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { track('section_view', { section: entry.target.getAttribute('data-section') || '' }); sectionObs.unobserve(entry.target); }
          });
        }, { threshold: 0.3 });
        var trackedSections = root.querySelectorAll('[data-section]');
        for (var i = 0; i < trackedSections.length; i++) sectionObs.observe(trackedSections[i]);
      }
      var timeOnPageFired = false;
      function fireTimeOnPage() { if (timeOnPageFired) return; timeOnPageFired = true; track('time_on_page', { seconds: Math.round((Date.now() - startTime) / 1000) }); }
      window.addEventListener('beforeunload', fireTimeOnPage);
      window.addEventListener('pagehide', fireTimeOnPage);
    }

    function track(eventType, data) {
      var payload = {
        event_type: eventType, timestamp: new Date().toISOString(), session_id: sessionId,
        variant: variant, profile: profile, fear: fear,
        device: /Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
        viewport_width: window.innerWidth || 0, page: 'omen-quiz-pdp'
      };
      if (data) { for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k]; } }
      if (window.console && window.console.log) { try { console.log('[OMEN-PDP track]', eventType, payload); } catch (e) {} }
      if (webhook) {
        try { var img = new Image(); img.src = webhook + '?data=' + encodeURIComponent(JSON.stringify(payload)) + '&t=' + Date.now(); } catch (e) {}
      }
    }
  }

  function getSessionId() {
    try {
      var sid = sessionStorage.getItem('omen_pdp_sid');
      if (!sid) { sid = 'sid_' + Math.random().toString(36).substring(2, 10) + '_' + Date.now().toString(36); sessionStorage.setItem('omen_pdp_sid', sid); }
      return sid;
    } catch (e) { return 'sid_mem_' + Math.random().toString(36).substring(2, 10); }
  }

  function getDataAttr(el, attr) { if (!el) return ''; return el.getAttribute(attr) || ''; }
})();
